import AWS from 'aws-sdk';
const awsConfig = {
  accessKeyId: 'AKIAZ3VABZB6CKQ3QQWI',
  secretAccessKey: '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',
  region: 'eu-west-1',
};
AWS.config.update(awsConfig);
const s3 = new AWS.S3();
export default s3;